import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../../../../hooks';

import StartVideoWebM from '../../../../../assets/media/free-drop/images/drop-start.webm';
import StartVideoMov from '../../../../../assets/media/free-drop/images/drop-start.mov';

interface FreeDropStartAnimationProps {

}

export const FreeDropStartAnimation: React.FC<FreeDropStartAnimationProps> = observer(() => {

  const videoRef = useRef<HTMLVideoElement>(null);

  const { freeDropStore } = useStore();
  const { showStartAnimation } = freeDropStore;

  useEffect(() => {
    if (showStartAnimation) {
      const video = videoRef.current;
      if (video) {
        video.play();
        video.addEventListener('ended', () => {
          freeDropStore.setShowStartAnimation(false);
        }, false);
      }
    }
  }, [showStartAnimation]);

  return (
    <div className={`free-drop-starts-animation-wrapper ${showStartAnimation ? 'active' : ''}`}>
      <video
        muted
        playsInline
        ref={videoRef}
      >
        <source
          src={StartVideoMov}
          type='video/quicktime; codecs="hvc1"'
        />
        <source
          type="video/webm"
          src={StartVideoWebM}
        />
      </video>
    </div>
  );
});
